/**
 * @desc 根据门店编码查询门店详情信息
 */

import { RequestConfig, request } from 'umi';
export interface Params {
  /** lat */
  lat?: string;
  /** lng */
  lng?: string;
  /** store_code */
  store_code: string;
}

function req(params: Params, config: Parameters<typeof request>[1] = {}) {
  return request<defs.store.GeneralHttpResponse<defs.store.StoreDetailVO>>(
    `/storeapi/api/v3/store/detail`,
    {
      params,
      method: 'get',
      ...(config || {}),
    },
  );
}
req.req = {} as Parameters<typeof req>[0];
req.res = {} as defs.store.GeneralHttpResponse<defs.store.StoreDetailVO>;
export default req;
